var XPortal = XPortal || {};
XPortal.FacetsSettings = XPortal.FacetsSettings || [];
XPortal.Facets = (function () {
    var self =
    {
        Items: [],
        Init: function (container) {
            container = $(container ? container : "body");
            container.find(".facetfilters-list-container").each(function () {
                self.List.InitFor($(this));
            });
            container.find(".facetfilters-tree-container").each(function () {
                self.Tree.InitFor($(this));
            });
        },
        GetAllFacets: function (id) {
            var result = [];
            $(".facetfilters-list-container").each(function () {
                const facetsContainer = $(this);
                const sttgs = self.Items[facetsContainer.attr("data-nodeid")];
                const relatedId = sttgs.type === "grid" ? sttgs.grid : sttgs.nodeid;
                if (id !== relatedId) return;
                const intiWith = sttgs.type === "grid" ? sttgs.InitData : null;                
                try {
                    if (intiWith && intiWith.facets)
                        result = result.concat(self.List.RestoreFrom(sttgs, facetsContainer, intiWith.facets));
                    else
                        result = result.concat(self.List.GetSelectedFacets(facetsContainer));
                } catch (ex) {
                    console.log("can't get selected fasets for fasets container.Error:" + ex, { sttgs, facetsContainer, ex });
                }
            });
            return result;
        },
        GetAllTreeFacets: function (gridId) {
            var result = [];
            $(".facetfilters-tree-container").each(function () {
                const facetsContainer = $(this);
                const sttgs = self.Items[facetsContainer.attr("data-nodeid")];
                if (gridId !== sttgs.grid) return;
                const intiWith = sttgs.type === "grid" ? sttgs.InitData : null;                
                try {
                    if (intiWith && intiWith.treeFacets)
                        result = result.concat(self.Tree.RestoreFrom(sttgs, facetsContainer, intiWith.treeFacets));
                    else
                        result = result.concat(self.Tree.GetSelectedFacets(facetsContainer));
                } catch (ex) {
                    console.log("can't get selected fasets for all tree fasets container-.Error:" + ex, { sttgs, facetsContainer, ex });
                }
            });
            return result;
        },
        List: {
            InitFor: function (container) {
                if (container.attr("data-processed") === "1") return;
                container.attr("data-processed", "1");
                let sttgs = XPortal.Main.GetSettingsFor(container);
                sttgs.facetType = "list";
                sttgs = Object.assign(sttgs, XPortal.Utils.readJsonStr(sttgs.opts, {}));                
                container.removeAttr("data-opts");
                delete sttgs.opts;
                self.Items[sttgs.nodeid] = sttgs;
                $(".facetvalue-selectall", container).on("change", function (e) {
                    e.preventDefault();
                    cleanUpInitialData(sttgs);
                    var facetFiltersContainer = $(this).closest(".facetfilters-facet");
                    var isChecked = $(this).prop("checked");
                    $(".facetfilters-facetvalues input[name='facetValue']", facetFiltersContainer).prop("checked", isChecked);
                    self.List.ApplyFacetFilters(container);
                });

                if (sttgs.type == "grid") {
                    const grid = $("#" + sttgs.grid);
                    grid.on("grid.onsearch", (e, searchRequest) => {
                        if ($(e.target).attr("id") !== sttgs.grid) return;
                        self.List.RebuildFacets(sttgs, container, searchRequest);
                    });
                }
                else self.List.RebuildFacets(sttgs, container, []);
            },
            GetSelectedFacets: function (facetsContainer) {
                var facetsInfo = [];
                $(".facetfilters-facet", facetsContainer).each(function () {
                    var facetInfoContainer = $(this);
                    var fieldName = facetInfoContainer.attr("data-fieldname");
                    var facetId = facetsContainer.attr("data-nodeid");

                    var selectedFacetValues = $(".facetfilters-facetvalues input[name='facetValue']:checked", facetInfoContainer).map(function () {
                        return { field: fieldName, value: $(this).attr("data-value") };
                    }).get();

                    facetsInfo.push({ facetId: facetId, values: selectedFacetValues });
                });

                return facetsInfo;
            },
            RestoreFrom: function (sttgs, facetsContainer, facets) {
                return facets;
            },
            RemoveAllFacets: function (facetsContainer) {
                facetsContainer.find(".facetfilters-facetvalues").empty();
            },
            ApplyFacetFilters: function (facetsContainer) {
                const sttgs = self.Items[facetsContainer.attr("data-nodeid")];
                clearTimeout(sttgs.applyInterval);
                sttgs.applyInterval = setTimeout(function () {
                    if (sttgs.type === "grid") {
                        const grid = $("#" + sttgs.grid);
                        if (!grid.length) return;

                        const ds = grid.data("kendoGrid").dataSource;
                        const currentFilters = ds.filter() ? ds.filter().filters : [];
                        ds.filter(currentFilters, ds.options);

                    } else {
                        const listFacets = self.List.GetSelectedFacets(facetsContainer);
                        self.List.RebuildFacets(sttgs, facetsContainer, listFacets);

                        const searchRequest = {};
                        searchRequest.facets = listFacets;
                        $(facetsContainer).trigger("facet.onsearch", searchRequest);
                    }
                }, 250);
            },
            RebuildFacets: function (sttgs, facetsContainer, searchRequest) {
                let postData = { selectedFacets: searchRequest, facetId: sttgs.nodeid };
                if (sttgs.type === "grid") {
                    const gridDataId = $("#" + sttgs.grid).attr("data-id");
                    const parentInfo = decodeURIComponent(XPortal.Grid.dictionaryParent[gridDataId]);
                    postData.selectedFacets = null;
                    postData.searchModel = searchRequest;
                    postData.parentInfo = parentInfo;
                };
                const fci = $(facetsContainer).data("XFacetCInfo") || { timeout: 0 };
                clearTimeout(fci.timeout);
                fci.timeout = setTimeout(function () {
                    jQuery.ajax({
                        data: kendo.stringify(postData), url: XPortal.Utils.EnsureInProfile(sttgs.url), method: "POST", dataType: "json", contentType: "application/json; charset=utf-8", cache: false,
                        headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                        success: function (result) {
                            self.List.RemoveAllFacets(facetsContainer);
                            self.List.CalculateFacetHeight(facetsContainer);
                            restoreFacetListView(sttgs, facetsContainer, result);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if (console) console.error("Unable to load list facet details for '" + facetsContainer.attr("data-nodeid") + "'!");
                        }
                    });
                }, 500);
                $(facetsContainer).data("XFacetCInfo", fci);
            },
            CalculateFacetHeight: function (facetsContainer) {
                var $wrapper = facetsContainer.closest('.dashboard-facetfilters-contentposition-left, .dashboard-facetfilters-contentposition-right').find('.dashboard-facetfilters-content');
                if (!$wrapper.length)
                    return;

                $wrapper.closest('.xsection').addClass('dashboard-facetfilters-section');
                facetsContainer.css({ 'max-height': $wrapper.outerHeight() });
            },
            CreateFacetValueItem: function (facetsContainer, facetValuesContainer, facetValue, facetValueTemplate) {
                var facetValueElement = $(facetValueTemplate(facetValue));
                facetValueElement.on("change", function (e) {
                    const sttgs = self.Items[facetsContainer.attr("data-nodeid")];
                    cleanUpInitialData(sttgs);
                    self.List.ApplyFacetFilters(facetsContainer);
                });

                facetValuesContainer.append(facetValueElement);
            }
        },
        Tree: {
            InitFor: function (container) {
                if (container.attr("data-processed") === "1") return;
                container.attr("data-processed", "1");
                let sttgs = XPortal.Main.GetSettingsFor(container);
                sttgs.facetType = "tree";
                sttgs = Object.assign(sttgs, XPortal.Utils.readJsonStr(sttgs.opts, {}));
                container.removeAttr("data-opts");
                delete sttgs.opts;
                self.Items[sttgs.nodeid] = sttgs;
                const dataSource = new kendo.data.HierarchicalDataSource({
                    transport: {
                        read: function (options) {
                            var facetId = container.attr("data-nodeid");
                            var treeView = $(".facetfilters-facet-tree", container).data("kendoTreeView");
                            var url = container.attr("data-url-tree");
                            var postData = {};

                            var searchModel = options.data.searchRequest ? options.data.searchRequest : container.data("searchRequest");
                            container.data("searchRequest", searchModel);
                            postData.searchModel = searchModel;

                            var gridId = container.attr("data-grid");
                            var gridDataId = $("#" + gridId).attr("data-id");
                            var parentInfo = XPortal.Grid.dictionaryParent[gridDataId];
                            postData.parentInfo = decodeURIComponent(parentInfo);

                            var checkChildren = false;
                            var parentNodeId = "";

                            // When "options.data.id" is set - we need to load data for single node
                            if (options.data.id) {
                                var dataItem = treeView.dataSource.get(options.data.id);
                                parentNodeId = dataItem.id;

                                if (dataItem.Items && dataItem.Items.length > 0) {
                                    var processedResult = self.Tree.ProcessResult(facetId, parentNodeId, dataItem.Items, false);
                                    options.success(processedResult);
                                    var dataItemToRecalculate = processedResult.length
                                        ? treeView.dataSource.get(processedResult[0].id)
                                        : dataItem;
                                    self.Tree.RecalculateDataItemsState(treeView, treeView.findByUid(dataItemToRecalculate.uid));
                                    return;
                                }

                                checkChildren = dataItem.checked;
                                url = container.attr("data-url-single-item");

                                postData.facetInfo = { facetId: facetId, values: self.Tree.GetTreeFacetInfo(treeView, dataItem) };
                            }

                            var expandedItemsIds = [];
                            var facetItemsToRecalculate = new Set();
                            // When "options.data.searchRequest" is set - we need to reload whole tree
                            if (options.data.searchRequest) {
                                treeView.element.find(".k-item").each(function () {
                                    var dataItem = treeView.dataItem(this);
                                    if (dataItem.expanded) {
                                        expandedItemsIds.push(dataItem.id);
                                        facetItemsToRecalculate.add(dataItem.id);
                                    }
                                    if (dataItem.checked) {
                                        var node = treeView.findByUid(dataItem.uid);
                                        while (node && node.length > 0) {
                                            var parentNode = treeView.parent(node);
                                            if (parentNode && parentNode.length) {
                                                var parentDataItem = treeView.dataItem(parentNode);
                                                facetItemsToRecalculate.add(parentDataItem.id);
                                            }
                                            node = parentNode;
                                        }
                                    }
                                });

                                url = container.attr("data-url-tree");

                                postData.facetId = facetId;

                                var facetsToRecalculate = Array.from(facetItemsToRecalculate.values()).map(function (id) {
                                    var dataItem = treeView.dataSource.get(id);
                                    return { facetId: facetId, values: self.Tree.GetTreeFacetInfo(treeView, dataItem) };
                                });
                                postData.facetsToRecalculate = facetsToRecalculate;
                            }

                            jQuery.ajax({
                                url: XPortal.Utils.EnsureInProfile( url),
                                method: "POST",
                                dataType: "json",
                                contentType: "application/json; charset=utf-8",
                                headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                                cache: false,
                                data: kendo.stringify(postData),
                                success: function (result) {
                                    var processedResult = self.Tree.ProcessResult(facetId, parentNodeId, result, checkChildren);
                                    options.success(processedResult);

                                    var treeView = $(".facetfilters-facet-tree", container).data("kendoTreeView");
                                    for (var i = 0; i < expandedItemsIds.length; i++) {
                                        var dataItem = treeView.dataSource.get(expandedItemsIds[i]);
                                        if (!dataItem) {
                                            continue;
                                        }

                                        var node = treeView.findByUid(dataItem.uid);
                                        if (node && node.length) {
                                            treeView.expand(node);
                                        }
                                    }

                                    var sortedRecalculatedFacetIds = Array.from(facetItemsToRecalculate).sort();
                                    for (var id of sortedRecalculatedFacetIds) {
                                        var dataItemToPreload = treeView.dataSource.get(id);
                                        if (dataItemToPreload && !dataItemToPreload.loaded()) {
                                            dataItemToPreload.load();
                                        }
                                    }

                                    if (parentNodeId) {
                                        var dataItemToRecalculate = processedResult.length
                                            ? treeView.dataSource.get(processedResult[0].id)
                                            : treeView.dataSource.get(parentNodeId);
                                        self.Tree.RecalculateDataItemsState(treeView, treeView.findByUid(dataItemToRecalculate.uid));
                                    }

                                    $(".facetfilters-facetvalues-empty", container).hide();
                                    if (!treeView.dataSource.data() || treeView.dataSource.data().length === 0) {
                                        $(".facetfilters-facetvalues-empty", container).show();
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    options.error(jqXHR, textStatus, errorThrown);
                                }
                            });
                        }
                    },
                    schema: {
                        model: {
                            data: "Items",
                            hasChildren: function (item) {
                                return !item.LastLevel;
                            }
                        }
                    }
                });
                $(".facetfilters-facet-tree", container).kendoTreeView({
                    template: kendo.template($("#facetfilters-tree-item-template").html()),
                    checkboxes: {
                        checkChildren: true
                    },
                    loadOnDemand: true,
                    autoBind: false,
                    dataSource: dataSource,
                    select: function (e) {
                        e.preventDefault();

                        var checkbox = $(e.node).find("input.k-checkbox[type='checkbox']:first");
                        checkbox.trigger("click");
                    },
                    check: function (e) {
                        if (e.node) {
                            var dataItem = e.sender.dataItem(e.node);
                            if (dataItem.headerDataItem) {
                                var itemsToCheck = dataItem.parent().filter(i => !i.headerDataItem);
                                itemsToCheck.forEach(function (item) {
                                    item.set("checked", dataItem.checked);
                                });
                            }

                            var treeView = $(".facetfilters-facet-tree", container).data("kendoTreeView");
                            self.Tree.RecalculateDataItemsState(treeView, $(e.node));
                        }

                        self.Tree.ApplyFacetFilters(container);
                    },
                    dataBound: function (e) {
                        var facetId = container.attr("data-nodeid");
                        var items = $("li.k-item", e.sender.element);
                        items.each(function (i) {
                            var dataItem = e.sender.dataItem($(this));
                            if (dataItem.headerDataItem) {
                                $(this).addClass("facetfilters-tree-header-item");
                            }

                            var showValuesCount = XPortal.FacetsSettings[facetId]
                                ? XPortal.FacetsSettings[facetId].some(fs => fs.field === dataItem.Field && fs.showValuesCount)
                                : false;
                            if (showValuesCount && dataItem.Count >= 0) {
                                $(".facetvalue-count", $(this)).show();
                            }
                            else {
                                $(".facetvalue-count", $(this)).hide();
                            }
                        });
                    }
                });


                var onGridSearch = function (e, searchRequest) {
                    if ($(e.target).attr("id") !== sttgs.grid) return;
                    self.Tree.RebuildFacets(sttgs, container, searchRequest);
                }
                $("#" + sttgs.grid).on("grid.onsearch", onGridSearch);
            },
            GetSelectedFacets: function (facetsContainer) {
                var facetId = facetsContainer.attr("data-nodeid");
                var treeView = $(".facetfilters-facet-tree", facetsContainer).data("kendoTreeView");
                var selectedFacets = [];
                if (!treeView || !treeView.element) return selectedFacets;
                treeView.element.find(".k-item").each(function () {
                    var dataItem = treeView.dataItem(this);
                    if (dataItem.headerDataItem) {
                        return;
                    }

                    if (dataItem.checked) {
                        selectedFacets.push({ facetId: facetId, values: self.Tree.GetTreeFacetInfo(treeView, dataItem) });
                    }
                });

                return selectedFacets;
            },
            RestoreFrom(sttgs, facetsContainer, treeFacets) {
                return treeFacets;
            },
            ApplyFacetFilters: function (facetsContainer) {
                const sttgs = self.Items[facetsContainer.attr("data-nodeid")];
                clearTimeout(sttgs.applyInterval);
                sttgs.applyInterval = setTimeout(function () {
                    var grid = $("#" + sttgs.grid);
                    if (!grid.length) return;
                    cleanUpInitialData(sttgs);
                    var ds = grid.data("kendoGrid").dataSource;
                    var currentFilters = ds.filter() ? ds.filter().filters : [];
                    ds.filter(currentFilters, ds.options);
                }, 250);
            },
            ProcessResult: function (facetId, parentNodeId, items, checkChildren) {
                if (!items || items.length === 0) {
                    return [];
                }

                for (var i = 0; i < items.length; i++) {
                    items[i].id = parentNodeId + "_" + items[i].Field + "_" + items[i].Value;
                    items[i].checked = checkChildren || items[i].Selected;
                }

                var fieldName = items[0].Field;
                var showZeroCountFacets = XPortal.FacetsSettings[facetId]
                    ? XPortal.FacetsSettings[facetId].some(fs => fs.field === fieldName && fs.showZeroCountFacets)
                    : false;

                var filteredResult = items.filter(function (facet) {
                    return showZeroCountFacets || (facet.Count > 0 || facet.Count == -1);
                });

                if (filteredResult.length > 0) {
                    var facetSettings = XPortal.FacetsSettings[facetId] ? XPortal.FacetsSettings[facetId].find(fs => fs.field === fieldName) : null;
                    var headerTitle = facetSettings ? facetSettings.title : fieldName;
                    var allItemsSelected = filteredResult.every(item => item.Selected);
                    var headerDataItem = { id: parentNodeId + "_" + fieldName + "_headerDataItem", checked: allItemsSelected, Items: [], LastLevel: true, Count: filteredResult.length, Title: headerTitle, Field: fieldName, headerDataItem: true };
                    filteredResult.unshift(headerDataItem);
                }

                return filteredResult;
            },
            RebuildFacets: function (sttgs, facetsContainer, searchRequest) {
                var treeView = $(".facetfilters-facet-tree", facetsContainer);
                if (!treeView.length) return;
                var fci = $(facetsContainer).data("XFacetCInfo") || { timeout: 0 };
                clearTimeout(fci.timeout);
                fci.timeout = setTimeout(function () {
                    var ds = treeView.data("kendoTreeView").dataSource;
                    ds.read({ searchRequest: searchRequest });
                }, 500);
                $(facetsContainer).data("XFacetCInfo", fci);
            },
            GetTreeFacetInfo: function (treeView, dataItem) {
                var treeFacetsInfo = [];
                var node = treeView.findByUid(dataItem.uid);
                while (node && node.length > 0) {
                    dataItem = treeView.dataItem(node);
                    treeFacetsInfo.push({ field: dataItem.Field, value: dataItem.Value });
                    node = treeView.parent(node);
                }
                return treeFacetsInfo.reverse();
            },
            RecalculateDataItemsState: function (treeView, node) {
                while (node && node.length) {
                    var dataItem = treeView.dataItem(node);
                    var itemsToValidate = dataItem.parent().filter(i => !i.headerDataItem);
                    var allSelected = itemsToValidate.every(item => item.checked);

                    var headerDataItem = dataItem.parent().find(i => i.headerDataItem);
                    if (headerDataItem) {
                        headerDataItem.set("checked", allSelected);
                    }

                    node = treeView.parent(node);
                }
            }
        },
        RestoreFrom: function (ginfo, facets, treeFacets) {            
            let i = "";
            for (i in self.Items) {
                const ix = self.Items[i];
                if (ix.facetType == "list") 
                    ix.InitData = { facets: ix.Initial, treeFacets: [] };
                else
                    ix.InitData = { facets: [], treeFacets: [] };
            }
            if (facets==null && treeFacets==null) return;
            let groups = _.groupBy(facets, (f) => f.facetId);
            for (i in groups) {
                const initial = (self.Items[i].InitData = self.Items[i].InitData || {});
                initial.facets = groups[i];
            }
            groups = _.groupBy(treeFacets, (f) => f.facetId);
            for (i in groups) {
                const initial = (self.Items[i].InitData = self.Items[i].InitData || {});
                initial.treeFacets = groups[i];
            }
        }
    };
    function restoreFacetListView(sttgs, facetsContainer, result) {
        $(".facetfilters-facetvalues-empty", facetsContainer).hide();
        if (!result || result.length === 0)
            return $(".facetfilters-facetvalues-empty", facetsContainer).show();

        var facetValueTemplate = kendo.template($("#facetfilters-list-item-template").html());
        var facetId = sttgs.nodeid;

        $(".facetfilters-facet", facetsContainer).each(function () {
            const facetFieldContainer = $(this);
            const fieldName = facetFieldContainer.attr("data-fieldname");
            const facetValues = result.filter(facet => facet.Name === fieldName);

            if (facetValues.length === 0) return facetFieldContainer.hide();
            facetFieldContainer.show();

            const facetValuesContainer = facetsContainer.find(".facetfilters-facet[data-fieldname='" + fieldName + "'] .facetfilters-facetvalues", facetFieldContainer);
            const showZeroCountFacets = XPortal.FacetsSettings[facetId]
                ? XPortal.FacetsSettings[facetId].some(fs => fs.field === fieldName && fs.showZeroCountFacets)
                : false;

            const facetsToShow = facetValues.filter(facet => {
                return facet.IsActive || (!facet.IsActive && (showZeroCountFacets || (facet.Count > 0 || facet.Count == -1)));
            });
            facetsToShow.forEach(function (facetValue) {
                self.List.CreateFacetValueItem(facetsContainer, facetValuesContainer, facetValue, facetValueTemplate);
            });

            const selectAllFacets = $(".facetfilter-title input[name='facetSelectAll']", facetFieldContainer);
            selectAllFacets.prop("checked", facetsToShow.every(facet => facet.IsActive));
            const headerValuesCount = $(".facetfilter-title .facetvalue-count", facetFieldContainer);
            headerValuesCountHtml = "(" + facetsToShow.length + ")";
            headerValuesCount.html(headerValuesCountHtml);

            const showValuesCount = XPortal.FacetsSettings[facetId]
                ? XPortal.FacetsSettings[facetId].some(fs => fs.field === fieldName && fs.showValuesCount)
                : false;
            const existsMaskedData = result.filter(x => x.Count < 0).length > 0;

            if (showValuesCount && !existsMaskedData)
                $(".facetvalue-count", facetFieldContainer).show();
            else
                $(".facetvalue-count", facetFieldContainer).hide();


            if (facetsToShow.length === 0) facetFieldContainer.hide();
        });

        if ($(".facetfilters-facet:visible", facetsContainer).length === 0)
            $(".facetfilters-facetvalues-empty", facetsContainer).show();
    };
    function cleanUpInitialData(sttgs) {
        if (sttgs.type != "grid" || !sttgs.InitData) return;
        sttgs.InitData.facets = null;
        sttgs.InitData.treeFacets = null;
    };
    return self;
}());
